export default __webpack_public_path__ + "static/media/subtract.5ad05d64.svg";